import script from "./TreeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeCard.vue?vue&type=script&setup=true&lang=js"

export default script